import { construirSombra } from '@/styles/theme';
import styled from 'styled-components';

export const ContainerDialog = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 996;
  overflow-y: auto;

  background-color: ${({ theme }) => theme.panel.solid};

  padding: ${({ theme }) => theme.spacing[5]}px 0px;
  gap: ${({ theme }) => theme.spacing[5]}px;

  border: 1 px solid ${({ theme }) => theme.colors.neutral.neutral_alpha[3]};
  border-radius: ${({ theme }) => theme.radius[4]}px;
  box-shadow: ${construirSombra('shadow_4')};
`;

export const ContainerTextoDialog = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0px ${({ theme }) => theme.spacing[6]}px;
  gap: ${({ theme }) => theme.spacing[3]}px;
`;

export const ContainerButtonsDialog = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  padding: 0px ${({ theme }) => theme.spacing[6]}px;
  gap: ${({ theme }) => theme.spacing[3]}px;
`;
